<template>
  <v-app id="lfmtools">
    <!--
    <v-navigation-drawer
      v-model="drawer"
      color="black"
      app
    >
      <v-list>
        <v-list-item
            @click="currentComponentName='Mainstream'"
          >
          <v-list-item-action>
            <v-icon large>mdi-gauge</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Mainstream Factor</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            @click="currentComponentName='DataExport'"
          >
          <v-list-item-action>
            <v-icon large>mdi-file-download</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Data Export</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    -->
    <v-app-bar
      app
      color="black"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>LastFM Data Export</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <component v-bind:is="currentComponent"></component>
    </v-content>
    <v-footer
      color="black"
      app
    >
    <span><a href="https://last.fm/user/ghan64">ghan64</a></span>
    </v-footer>
  </v-app>
</template>

<script>
  import Home from './components/Home';
  import Mainstream from './components/Mainstream';
  import DataExport from './components/DataExport';

  export default {
    components: {
      Home,
      Mainstream,
      DataExport
    },

    props: {
      source: String,
    },

    data: () => ({
      drawer: null,
      currentComponentName: 'DataExport'
    }),

    computed: {
      currentComponent: function() {
        return this.currentComponentName
      }
    }
  }
</script>
